export interface SchemaFields {
  internalid: string;
  branch: string;
  codeschema: string;
  itemid: string;
  nameschema: string;
  field: string;
  label: string;
  type: string;
  customized: boolean;
  required?: boolean;
  visible?: boolean;
  maxlength?: number;
  grid?: number;
  divider?: string;
}

export enum SchemaEnum {
  notification = '000001',
  customer = '000002',
  contacts = '000003',
  phoneContacts = '000004',
  financialStatusCustomer = '000005',
  priceListHeader = '000006',
  priceListItem = '000007',
  paymentConditions = '000008',
  salesOrders = '000009',
  salesOrdersItems = '000010',
  carriers = '000011',
  products = '000012',
  productBalance = '000013',
  salesOrderQueue = '000014',
  accessLog = '000015',
  prospects = '000016',
  salesBudgets = '000017',
  salesBudgetsItems = '000018',
  schemasFields = '000019',
  intermediaries = '000020',
  pdfcustom = '000021',
  commissions = '000022'
}

export interface FieldsDecimals{
  amount: number;
  discount: number;
  discountamount: number;
  expenses: number;
  freight: number;
  insurance: number;
  pricelist: number;
  quantity: number;
  quantitydelivered: number;
  unitprice: number;
}
